import { useTranslation } from 'react-i18next'

import { Badge, TableCell, TableRow } from '@percent/lemonade'
import type { GivingCampaignGroupPartnerDto } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'
import { GroupsActionsMenu } from './GroupsActionsMenu/GroupsActionsMenu'

export type GroupsTableRowProps = Readonly<{
  group: GivingCampaignGroupPartnerDto
}>

export function GroupsTableRow({ group }: GroupsTableRowProps) {
  const { t } = useTranslation()
  const isArchived = group.deletedAt !== null

  return (
    <TableRow key={group.id}>
      <TableCell>{group.name}</TableCell>
      <TableCell>{group.campaignsCount}</TableCell>
      <TableCell>
        <Badge variant={isArchived ? 'default' : 'positive'}>
          {isArchived ? t('status.archived') : t('status.active')}
        </Badge>
      </TableCell>
      <TableCell>{!isArchived && <GroupsActionsMenu group={group} />}</TableCell>
    </TableRow>
  )
}
